export default "__VITE_ASSET__BSAUqLH7__"